import { t } from 'i18next'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Fade,
  Chip,
  useTheme,
  alpha
} from '@mui/material'
import { useState, useEffect } from 'react'

export interface CongratsBlockProps {
  message: string
  calendarName: string // Add this prop
}

export default function CongratsBlock(props: CongratsBlockProps) {
  const [visible, setVisible] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Fade in={visible} timeout={800}>
      <Card elevation={0} sx={{ bgcolor: 'transparent' }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h4"
              component="h2"
              fontSize={'24px'}
              fontFamily={'NotoSans'}
              sx={{
                fontWeight: 'bold',
                color: theme.palette.text.primary,
                mb: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2
              }}
            >
              {t('congratulations')}
              <Box
                component="span"
                sx={{
                  fontSize: '20px',
                  position: 'relative',
                  mb: '8px',
                  animation: 'bounce 1.5s ease-in-out infinite',
                  '@keyframes bounce': {
                    '0%, 20%, 50%, 80%, 100%': {
                      transform: 'translateY(0)'
                    },
                    '40%': {
                      transform: 'translateY(-10px)'
                    },
                    '60%': {
                      transform: 'translateY(-5px)'
                    }
                  }
                }}
              >
                🎉
              </Box>
            </Typography>
          </Box>

          <Typography
            variant="body1"
            fontSize={'16px'}
            fontFamily={'NotoSans'}
            lineHeight={'24px'}
            sx={{
              color: 'black',
              lineHeight: 1.6,
              maxWidth: '400px',
              mx: 'auto'
            }}
          >
            {(() => {
              const nameWithQuotes = `"${props.calendarName}"`
              const nameIndex = props.message.indexOf(nameWithQuotes)

              if (nameIndex === -1) return props.message

              const beforeName = props.message.substring(0, nameIndex + 1)
              const afterName = props.message.substring(
                nameIndex + nameWithQuotes.length - 1
              )

              return (
                <>
                  {beforeName}
                  <Box
                    fontFamily={'NotoSans'}
                    component="span"
                    sx={{ fontWeight: 600 }}
                  >
                    {props.calendarName}
                  </Box>
                  {afterName}
                </>
              )
            })()}
          </Typography>
        </CardContent>
      </Card>
    </Fade>
  )
}
